import _defineProperty from "/codebuild/output/src2469753568/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2469753568/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "activeKey", "bsPrefix", "className", "onSelect", "flush", "alwaysOpen"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import classNames from 'classnames';
import * as React from 'react';
import { useMemo } from 'react';
import { useUncontrolled } from 'uncontrollable';
import { useBootstrapPrefix } from './ThemeProvider';
import AccordionBody from './AccordionBody';
import AccordionButton from './AccordionButton';
import AccordionCollapse from './AccordionCollapse';
import AccordionContext from './AccordionContext';
import AccordionHeader from './AccordionHeader';
import AccordionItem from './AccordionItem';
import { jsx as _jsx } from "react/jsx-runtime";
var Accordion = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useUncontrolled = useUncontrolled(props, {
      activeKey: 'onSelect'
    }),
    _useUncontrolled$as = _useUncontrolled.as,
    Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
    activeKey = _useUncontrolled.activeKey,
    bsPrefix = _useUncontrolled.bsPrefix,
    className = _useUncontrolled.className,
    onSelect = _useUncontrolled.onSelect,
    flush = _useUncontrolled.flush,
    alwaysOpen = _useUncontrolled.alwaysOpen,
    controlledProps = _objectWithoutProperties(_useUncontrolled, _excluded);
  var prefix = useBootstrapPrefix(bsPrefix, 'accordion');
  var contextValue = useMemo(function () {
    return {
      activeEventKey: activeKey,
      onSelect: onSelect,
      alwaysOpen: alwaysOpen
    };
  }, [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/_jsx(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({
      ref: ref
    }, controlledProps), {}, {
      className: classNames(className, prefix, flush && "".concat(prefix, "-flush"))
    }))
  });
});
Accordion.displayName = 'Accordion';
export default Object.assign(Accordion, {
  Button: AccordionButton,
  Collapse: AccordionCollapse,
  Item: AccordionItem,
  Header: AccordionHeader,
  Body: AccordionBody
});